module.exports = __webpack_public_path__ + "img/design-thinking.7a86f087.svg";